export enum Tabs {
  HOME = 'HOME',
  WORKSPACE = 'WORKSPACE',
  NOTEBOOK = 'NOTEBOOK',
  ASSETS = 'ASSETS',
  SCENARIOS = 'SCENARIOS',
  USAGE = 'USAGE',
  DOCS = 'DOCS',
  ADMIN = 'ADMIN',
  ONTOLOGY = 'ONTOLOGY',
  SETTINGS = 'SETTINGS',
  TEAM = 'TEAM',
}
